<template>
    <div class="mod mod-half mod-fbl mod-tab-block">
        <h2><i>11</i>多空对比<span class="icon-help" v-on:click="toggle">?</span></h2>
        <div class="chart-tab-block">
            <span v-for="(item,index) in tabs" :class="{'cur':curTab==index}" @click="curTab=index,tabChange(index)">{{item}}</span>
        </div>
        <keep-alive>
            <component v-bind:is="curTabComponent"></component>
        </keep-alive>
        <p class="help-pop" style="display: block" v-show="isHelp">市场上的投资者买卖委托单之差预示对市场未来预期的判断，若买入委托单持续上涨，意味着未来走势持乐观态度。</p>
    </div>
</template>

<script>
    import dkdbSh from './dkdbSh.vue';      // 上证指数
    import dkdbSz from './dkdbSz.vue';     // 深证指数
    export default {
        data () {
            return {
                isHelp:false,
                tabs:['上证指数','深证指数'],
                curTab:0,
                curTabComponent: 'dkdbSh'
            }
        },
        components: {
            dkdbSh,
            dkdbSz
        },
        methods: {
            toggle: function () {
                this.isHelp =! this.isHelp;
            },
            tabChange:function(index){
                switch(index)
                {
                    case 1:
                        this.curTabComponent = 'dkdbSz';
                        break;
                    default:
                        this.curTabComponent = 'dkdbSh';
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/home/components/dkdb.vue